export default function tabReducer(_, action) {
  switch (action.type) {
    case 'select':
      return { activeTab: action.activeTab };
    default:
      throw new Error('Invalid action type')
  }
}
